export default "__VITE_ASSET__4OP$2fTy__"